import React from 'react';
import { Link } from 'react-router-dom';
import { projectTypesData } from '../data/mock';

const ProjectTypes = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container text-center">
          <h1 className="hero-large mb-6">Healthcare Facilities We Build</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            From Primary Health Centres to Post-Graduate Institutes of up to 3600 beds. Comprehensive coverage across all levels of healthcare delivery.
          </p>
        </div>
      </section>

      {/* Primary Level */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div>
              <img 
                src={projectTypesData.primary.image} 
                alt="Primary Healthcare Facilities"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '0px'
                }}
              />
            </div>
            <div>
              <h2 className="hero-medium mb-4">{projectTypesData.primary.title}</h2>
              <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
                {projectTypesData.primary.description}
              </p>
              <ul className="space-y-3">
                {projectTypesData.primary.facilities.map((facility, index) => (
                  <li key={index} className="body-regular" style={{ color: 'var(--text-primary)' }}>
                    • {facility}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Secondary Level */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div className="order-2 lg:order-1">
              <h2 className="hero-medium mb-4">{projectTypesData.secondary.title}</h2>
              <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
                {projectTypesData.secondary.description}
              </p>
              <ul className="space-y-3">
                {projectTypesData.secondary.facilities.map((facility, index) => (
                  <li key={index} className="body-regular" style={{ color: 'var(--text-primary)' }}>
                    • {facility}
                  </li>
                ))}
              </ul>
            </div>
            <div className="order-1 lg:order-2">
              <img 
                src={projectTypesData.secondary.image} 
                alt="Secondary Healthcare Facilities"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '0px'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Tertiary Level */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div>
              <img 
                src={projectTypesData.tertiary.image} 
                alt="Tertiary Healthcare Facilities"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '0px'
                }}
              />
            </div>
            <div>
              <h2 className="hero-medium mb-4">{projectTypesData.tertiary.title}</h2>
              <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
                {projectTypesData.tertiary.description}
              </p>
              <ul className="space-y-3">
                {projectTypesData.tertiary.facilities.map((facility, index) => (
                  <li key={index} className="body-regular" style={{ color: 'var(--text-primary)' }}>
                    • {facility}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Special Category */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="hero-medium mb-4">{projectTypesData.special.title}</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              {projectTypesData.special.description}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projectTypesData.special.facilities.map((facility, index) => (
              <div 
                key={index}
                style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)'
                }}
              >
                <p className="body-large" style={{ color: 'var(--text-primary)' }}>
                  {facility}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Government Healthcare Institutions */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="hero-medium mb-4">{projectTypesData.government.title}</h2>
            <p className="body-large mb-6" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              Specialized experience in delivering healthcare infrastructure for government institutions at central, state, and municipal levels
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="heading-2 mb-4">Central Government Institutions</h3>
              <ul className="space-y-2">
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• ESIC Hospitals</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Railway Hospitals</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Defence / Armed Forces Hospitals</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• BARC Hospital</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Port Trust Hospitals</li>
              </ul>
            </div>

            <div>
              <h3 className="heading-2 mb-4">State & Municipal Institutions</h3>
              <ul className="space-y-2">
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• ESIS Hospitals</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• PHCs, RHs, SDHs, DHs</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Medical Colleges & Hospitals</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• UHCs/UPHCs under Municipal Corporations</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Mother and Child and Women Hospitals</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Research & Referral Institutes */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="hero-medium mb-4">Research & Referral Institutes</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              Specialized infrastructure for advanced medical research and virology laboratories
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-2 mb-3">ICMR Institutes</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                NIV Pune, MIV Pune, and other premier medical research institutions
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-2 mb-3">Regional Virology Labs</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                BSL-2 and BSL-3 laboratory infrastructure for advanced virology research
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-2 mb-3">NBS Laboratories</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Specialized infrastructure capability for National Biosafety Standard laboratories
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding cta-section-dark">
        <div className="container text-center">
          <h2 className="hero-medium mb-4 cta-heading-light">
            Your Healthcare Facility Project Starts Here
          </h2>
          <p className="body-large mb-8 cta-text-light">
            Let's discuss your specific requirements and project scope.
          </p>
          <Link 
            to="/contact" 
            className="btn-primary btn-light-on-dark"
          >
            Request Project Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProjectTypes;
